import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useUpdateShift = () => {
    const baseUrl = '/api';

    return useMutation({
        mutationFn: (value: { Id: number; Shift: string }) =>
            axiosRequest
                .put(`${baseUrl}/updateShift/${value.Id}`, value.Shift)
                .then((res) => {
                    return res.data;
                }),
    });
};
